import React from "react";
import Avatar from "../../avatar";
import cx from "classnames";

const GroupConversationItem = ({
	title,
	preview,
	lastSender,
	lastUpdate,
	photoUrls,
	unreadCount = 0,
	membersCount = 0,
	className,
	dimension = "thumb6",
	conversationId,
}: {
	title: string;
	preview: string;
	lastSender: string;
	lastUpdate: string;
	photoUrls?: string[];
	unreadCount?: number;
	membersCount?: number;
	className?: string;
	dimension?: string;
	conversationId: string;
}) => (
	<div
		className={cx("item", "conversation", "medium", "groupConversation", className, { unread: unreadCount > 0 })}
		data-members-count={membersCount}
		id={conversationId}
	>
		{photoUrls && photoUrls.length > 0 ? (
			<div className="itemImage">
				<div className="avatars">
					{photoUrls.map((url, key) => (
						<Avatar photoUrl={url} size={dimension} key={key} />
					))}
				</div>
			</div>
		) : null}
		<div className="itemBody">
			<div className="combinedLabels">
				<div className="title">
					<div className="longTextWrap">
						<div className="longText">
							{title} {unreadCount ? `(${unreadCount})` : ""}
						</div>
					</div>
				</div>
				<div className="time">{lastUpdate}</div>
			</div>
			<div className="meta">
				{preview ? (
					<div className="longTextWrap">
						<div className="longText">
							{lastSender}: {preview}
						</div>
					</div>
				) : null}
			</div>
		</div>
	</div>
);

export default GroupConversationItem;
